export type GeneratedDocuments = {
  fileName: string,
  key: string,
  url: string,
  lastModified: string
}

export enum ProcessNames {
  GENERATE_PACKING_SLIPS = 'generate_packing_slips',
  GENERATE_PICKING_LIST = 'generate_picking_list',
  UPDATE_ORDERS = 'update_orders',
  IMPORT_ORDERS = 'import_orders',
  GROUP_SHIPPING_LABELS = 'group_shipping_labels'
}

export type ProcessResultError = {
    detail?: string, code?: string
  }

export type ImportProcessResultError = ProcessResultError & {
    source?: {
      pointer?: string
      pointer_source_column?: number
      row_index?: number
    }
  }

export type ImportProcessResult = {
  status?: "success" | "error"
  ids?: string[] | number[]
  errors?: ImportProcessResultError[]
}

export type GroupLabelsProcessResult = {
  status?: "success" | "error"
  cross_warehouse_shipment?: string[] | number[],
  unavailable_sku_shipment?: string[] | number[],
  result_files?: string[]
  errors?: ProcessResultError[]
}

export type UpdateOrdersProcessResult = {
  status?: "success" | "error"
  ids?: string[] | number[]
  errors?: ProcessResultError[]
}

export type ProcessStatus = {
  process: ProcessNames,
  lastRun: string,
  isRunning: boolean
  result?: ImportProcessResult | GroupLabelsProcessResult | UpdateOrdersProcessResult
}

export type UpdateOrdersConfig = {
  functions: string[],
  has_product_data_file?: boolean
  use_batch_create?: boolean
  update_orders_product_data_file_url?: string
}

export type ClientConfiguration = {
  logo: string
  processes: ProcessNames[]
  update_orders_config?: UpdateOrdersConfig
}

export type UploadFileUrl = {
  url: { url: string, fields: Record<string, string> },
  object_key: string
}